export enum QuestionAnwserType {
    DATE = "date",
    BOOLEAN = "boolean",
    STRING = "string",
    TIMESLOT = "timeslot",
}
